module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-site-768x591.d6c64168.jpg";